import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';

export interface LinkedProfile {
  tenantId: number;
  membershipId: number;
  companyName: string;
  companyType: string;
}

/** `users.company_type` values with a label; anything else shows no type. */
export const TYPE_LABELS: Record<string, string> = {
  restaurant: 'PROFILES.TYPES.RESTAURANT',
  transfer: 'PROFILES.TYPES.TRANSFER',
  default: 'PROFILES.TYPES.APPOINTMENTS',
  defaultplus: 'PROFILES.TYPES.APPOINTMENTS',
};

/**
 * Picker uçları (C29, I.franchise) — kimlik bilgisi taşımayanlar. Bağlama ve
 * işletmeye giriş gövdede kimlik taşır; onlar AuthService'te (tek gönderim).
 */
@Injectable({ providedIn: 'root' })
export class ProfilesService {
  private readonly url = `${environment.baseUrl}/auth/profiles`;

  constructor(private http: HttpClient) {}

  list(): Observable<LinkedProfile[]> {
    return this.http.get<LinkedProfile[]>(this.url);
  }

  unlink(tenantId: number): Observable<void> {
    return this.http.delete<void>(`${this.url}/${tenantId}`);
  }
}
